module.exports = __webpack_public_path__ + "img/logo.png?5095b31bf7bc49ab0ab09b2a56d4e9c0";